<template>
  <b-modal
    hide-footer
    id="modal-company"
    ref="modal-company"
    size="lg"
    title="เพิ่มข้อมูล"
  >
    <b-row>
      <b-col cols="12">
        <b-form-group label="รหัสผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)">
          <b-form-input
            v-model="company.compId"
            readonly="readonly"
            class="col-6"
            required
          />
        </b-form-group>

        <b-form-group label="ชื่อผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)">          
          <b-row>
            <vue-autosuggest
              :v-model="company.companyDetail"
              :value="company.companyDetail"
              :suggestions="filteredOptions"
              :limit="limit"
              :input-props="inputProps"
              class="col-6"
              @selected="onSelected"
              @input="onInputChange"
              :get-suggestion-value="getSuggestionValue"
            >
              <template slot-scope="{ suggestion }">
                <span class="my-suggestion-item">{{
                  suggestion.item.label
                }}</span>
              </template>
            </vue-autosuggest>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group label="ที่ตั้ง/ที่อยู่">
          <CompanyAddress
          v-if="company.address !== null && company.address !== undefined"
          :address="company.address"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <footer id="modal-company___BV_modal_footer_" class="modal-footer">
      <button type="button" class="btn btn-primary" block @click="onSubmit">บันทึก</button>
    </footer>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BModal,
  BForm,
  BButton,
  BFormTextarea,
} from "bootstrap-vue";

import CompanyAddress from '../../components/CompanyAddress.vue';

import { VueAutosuggest } from "vue-autosuggest";
import * as companyStore from "@/store/api/company/index.js";

import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    vSelect,
    VueAutosuggest,
    CompanyAddress,
  },
  props: {
    company: {
      type: Object,
      default() {
        return {
          compId : null,
          companyDetail : null,
          address : null,
        }
      }
    },
  },
  data() {
    return {
      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: "companyName",
        class: "form-control",
        placeholder: "ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)",
      },
      limit: 10,
    };
  },
  created() {
  },
  methods: {
    onSubmit() {
      // console.log('this.company.companyDetail', this.company.companyDetail)
      console.log('this.company.compId', this.company.compId, typeof(this.company.compId))
      // console.log('this.company.address', this.company.address)

      if (this.company.compId === null || this.company.compId === '' || this.company.compId === undefined) {
        this.$bvToast.toast("กรุณาเลือกผู้ประกอบการ", {
            title: `กรุณาเลือกผู้ประกอบการs`,
            variant: "danger",
            solid: false,
          });
        return
      }

      if (this.company.compId !== null && this.company.compId !== '') {
        this.$emit("handle-submit");
      }
      
    },
    onSelected(option) {
      const _this = this

      this.company.companyDetail = option.item.label;
      this.company.compId = option.item.value;
      console.log(option);
      // get company address detial
      companyStore
        .getAddressDetail(option.item.value)
        .then((response) => {
          _this.company.address = response.data.data
        })
        .catch((error) => {
          console.log("error", error);
        });

    },
    onInputChange(text) {
      const _this = this;

      if (text === "" || text === undefined) {
        return;
      }

      if (text.length < 3) {
        return;
      }

      companyStore
        .getByName(text)
        .then((response) => {
          console.log("response", response);
          /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
          const filteredCompany = response.data.data.slice(0, this.limit);
          _this.filteredOptions = [
            {
              data: filteredCompany,
            },
          ];

          console.log("_this", _this.filteredOptions);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.label;
    },
  },
};
</script>

<style></style>
